(() => {
  if (window.__brandosRequiredPaymentChoiceV4) return;
  window.__brandosRequiredPaymentChoiceV4 = true;

  const rootPath = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  const productRoot = () => document.querySelector('[data-brandos-prepaid-incentive] [data-brandos-context="product"]')?.closest('[data-brandos-prepaid-incentive]') || null;
  const productChoice = (root) => root?.querySelector('[data-brandos-context="product"] input[name="brandos-payment-preference"]:checked') || null;
  const promptFor = (root) => root?.querySelector('[data-brandos-choice-error]') || null;
  let desiredMode = 'none';
  let syncedMode = null;
  let syncRunner = null;

  const setPrompt = (root, message, isError = false) => {
    const prompt = promptFor(root);
    if (!prompt) return;
    prompt.hidden = false;
    prompt.textContent = message;
    prompt.setAttribute('data-error', isError ? 'true' : 'false');
    if (isError) prompt.scrollIntoView({behavior: 'smooth', block: 'center'});
  };

  const saveMode = async (mode) => {
    const prepaid = mode === 'prepaid';
    const response = await fetch(rootPath() + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({
        attributes: {
          brandos_prepaid_offer: prepaid ? 'PREPAID5' : '',
          brandos_payment_preference: mode === 'prepaid' ? 'PREPAID' : mode === 'cod' ? 'COD' : ''
        },
        discount: prepaid ? 'PREPAID5' : ''
      })
    });
    if (!response.ok) throw new Error('Unable to synchronize payment choice');
  };

  const drainSync = async () => {
    while (syncedMode !== desiredMode) {
      const target = desiredMode;
      let saved = false;
      for (let attempt = 0; attempt < 3 && !saved; attempt += 1) {
        try {
          await saveMode(target);
          saved = true;
        } catch (error) {
          if (attempt < 2) await new Promise((resolve) => setTimeout(resolve, 350 * (attempt + 1)));
        }
      }
      if (!saved) {
        if (target === desiredMode && target !== 'none') setPrompt(productRoot(), 'Unable to save your payment choice. Please check your connection and try again.', true);
        break;
      }
      syncedMode = target;
    }
    syncRunner = null;
    window.__brandosPaymentSyncPromise = null;
  };

  const scheduleSync = (mode) => {
    desiredMode = mode;
    window.__brandosPaymentSyncValue = mode;
    if (!syncRunner) {
      syncRunner = drainSync();
      window.__brandosPaymentSyncPromise = syncRunner;
    }
    return syncRunner;
  };

  const relevantForm = (root) => {
    const id = root?.getAttribute('data-brandos-product-form-id');
    return id ? document.getElementById(id) : document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  };

  const resetProductChoice = () => {
    const root = productRoot();
    if (!root) return;
    root.querySelectorAll('[data-brandos-context="product"] input[name="brandos-payment-preference"]').forEach((input) => { input.checked = false; });
    root.setAttribute('data-brandos-payment-mode', 'prepaid');
    try { localStorage.removeItem('brandosPaymentPreference'); } catch (error) {}
    setPrompt(root, 'Required: Select Prepaid payment or Cash on Delivery before adding to cart.');
    scheduleSync('none');
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resetProductChoice, {once: true});
  else resetProductChoice();
  window.addEventListener('pageshow', (event) => { if (event.persisted) resetProductChoice(); });

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('[data-brandos-prepaid-choice], [data-brandos-cod-choice]')) return;
    const root = input.closest('[data-brandos-prepaid-incentive]');
    const mode = input.value === 'prepaid' ? 'prepaid' : 'cod';
    root?.setAttribute('data-brandos-payment-mode', mode);
    try { localStorage.setItem('brandosPaymentPreference', mode); } catch (error) {}
    setPrompt(root, mode === 'prepaid' ? 'Prepaid selected - 5% discount will be applied.' : 'Cash on Delivery selected - INR 50 handling fee applies.');
    scheduleSync(mode);
  });

  const blockUnselected = (event, root) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    setPrompt(root, 'Please select Prepaid payment or Cash on Delivery before adding to cart.', true);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="add"], input[name="add"], .product-form__submit, [id^="AddToCart-"]');
    if (!button) return;
    const root = productRoot();
    const form = relevantForm(root);
    if (!root || !form || (button.form && button.form !== form)) return;
    const selected = productChoice(root);
    if (!selected) return blockUnselected(event, root);
    scheduleSync(selected.value === 'prepaid' ? 'prepaid' : 'cod');
  }, true);

  document.addEventListener('submit', (event) => {
    const root = productRoot();
    if (!root || event.target !== relevantForm(root)) return;
    const selected = productChoice(root);
    if (!selected) return blockUnselected(event, root);
    scheduleSync(selected.value === 'prepaid' ? 'prepaid' : 'cod');
    // Keep the theme's native submit untouched: no preventDefault and no requestSubmit.
  }, true);
})();
